/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/18/16.
 */
'use strict';
angular.module('prism-ui.package').service('CreateProxyService',
	function ($q, WorkflowExecutionResourceFactory, WorkflowService) {
		var CREATE_VIDEO_PROXY_KEY = '_createProxies',
			CREATE_PRE_POST_PROXY_KEY = 'prePostRollProxyWorkflow',
			CREATE_COMPONENT_MASTER_PROXY = '_createVideoComponentProxy',
			CREATE_AUDIO_PROXY_KEY = '_createProxies',
			CREATE_IMAGE_PROXY_KEY = '_createProxies';

		var self = this;

		self.createVideoProxy = function (videoId) {
			var workflowParameters = {
				subject: '[VideoPackageContent.' + videoId + ']'
			};
			return WorkflowService.startWorkflow(CREATE_VIDEO_PROXY_KEY, workflowParameters);
		};

		self.createComponentMasterProxy = function (videoId) {
			var workflowParameters = {
				subject: '[VideoComponentMaster.' + videoId + ']'
			};
			return WorkflowService.startWorkflow(CREATE_COMPONENT_MASTER_PROXY, workflowParameters);
		};

		self.createAudioProxy = function (audioId) {
			var workflowParameters = {
				subject: '[AudioPackageContent.' + audioId + ']'
			};
			return WorkflowService.startWorkflow(CREATE_AUDIO_PROXY_KEY, workflowParameters);
		};

		self.createImageProxy = function (imageId) {
			var workflowParameters = {
				subject: '[ImagePackageContent.' + imageId + ']'
			};
			return WorkflowService.startWorkflow(CREATE_IMAGE_PROXY_KEY, workflowParameters);
		};

		self.createPrePostRollProxy = function (prePostId) {
			var workflowParameters = {
				subject: '[PrePostRollAsset.' + prePostId + ']'
			};
			WorkflowService.startWorkflow(CREATE_PRE_POST_PROXY_KEY, workflowParameters);
		};
	});
